import styled from 'styled-components';
// import theme from '../theme';

const GenericStatusStyles = styled.div``;

export default GenericStatusStyles;
